// ── Shared Types ──────────────────────────────────────────
// Types used by both frontend (web) and backend (api)

// ── Smoking Unit Helpers ──────────────────────────────────
export type SmokingType = 'pod' | 'cigarette' | 'both';

/** Get the Thai unit label based on smoking type */
export function getSmokingUnit(type?: string): string {
  switch (type) {
    case 'cigarette': return 'มวน';
    case 'pod': return 'คำ';
    case 'both': return 'ครั้ง';
    default: return 'ครั้ง';
  }
}

/** Get cost label: "ต่อคำ", "ต่อมวน", "ต่อครั้ง" */
export function getCostLabel(type?: string): string {
  return `ต่อ${getSmokingUnit(type)}`;
}

/** Get emoji for smoking type */
export function getSmokingEmoji(type?: string): string {
  switch (type) {
    case 'pod': return '💨';
    case 'cigarette': return '🚬';
    case 'both': return '🔄';
    default: return '🚬';
  }
}

export interface User {
  id: string;
  displayName: string;
  pictureUrl?: string;
  statusMessage?: string;
  role?: 'owner' | 'viewer';
  ownerUserId?: string;
  mode: 'quit' | 'reduce';
  dailyPuffLimit: number;
  quitDate?: Date;
  costPerPuff: number;
  nicotinePerPuff: number;
  puffsPerPod?: number;
  podPrice?: number;
  smokingType?: string;
  smokingDuration?: string;
  dailyAmount?: number;
  quitReasons?: string[];
  monthlyCost?: number;
  onboardingCompleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface PuffLog {
  id: string;
  userId: string;
  count: number;
  loggedAt: Date;
  trigger?: string;
  notes?: string;
}

export interface DailyStats {
  date: string;
  count: number;
}

export interface Stats {
  todayCount: number;
  dailyLimit: number;
  period: string;
  totalPuffs: number;
  moneySaved: number;
  nicotineAvoided: number;
  lastPuffAt: Date | null;
  dailyStats: Record<string, number>;
  chartData: DailyStats[];
}

export interface Milestone {
  id: string;
  userId: string;
  type: string;
  achievedAt: Date;
  acknowledged: boolean;
}

export type TriggerType = 'stress' | 'social' | 'habit' | 'boredom' | 'craving' | 'other';

export const TRIGGER_LABELS: Record<TriggerType, string> = {
  stress: 'Stress',
  social: 'Social',
  habit: 'Habit',
  boredom: 'Boredom',
  craving: 'Craving',
  other: 'Other',
};
